import { render, staticRenderFns } from "./miniProgramModal.vue?vue&type=template&id=0c9f235f&scoped=true"
import script from "./miniProgramModal.vue?vue&type=script&lang=js"
export * from "./miniProgramModal.vue?vue&type=script&lang=js"
import style0 from "./miniProgramModal.vue?vue&type=style&index=0&id=0c9f235f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f235f",
  null
  
)

export default component.exports